import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationInput } from '@challenger/care/components/confirmation/confirmation.model';

@Component({
  selector: 'vm-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
})
export class ArticleComponent {
  @Input() backLabel = 'Back';
  @Input() content: ConfirmationInput;
  @Output() tileClick = new EventEmitter();

  constructor(private route: ActivatedRoute, private router: Router) {}

  onBack(e) {
    history.back();
  }

  onTileClick(tile) {
    this.router.navigate([tile.uid], { relativeTo: this.route });
  }
}
